import React from 'react';
import { Trophy, Target, Shield, Heart } from 'lucide-react';
const benefits = [{
  title: 'Build Confidence',
  description: 'Watch your child stand taller and speak clearer. We help students overcome challenges and believe in themselves.',
  icon: Trophy,
  color: 'text-yellow-400'
}, {
  title: 'Focus & Discipline',
  description: 'Developing the ability to listen, follow directions, and focus on tasks - skills that translate directly to better grades.',
  icon: Target,
  color: 'text-[#00D4FF]'
}, {
  title: 'Self-Defense Skills',
  description: 'Practical, effective techniques to keep you and your family safe. Empowerment through preparation and awareness.',
  icon: Shield,
  color: 'text-[#FF6B35]'
}, {
  title: 'Anti-Bullying',
  description: 'We teach kids how to avoid conflict, use their voice, and defend themselves only when absolutely necessary.',
  icon: Heart,
  color: 'text-red-400'
}];
export function HomeBenefitsSection() {
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-995">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gray-50 -skew-x-12 translate-x-20 z-0" data-id="element-996" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-997">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-998">
          <h2 className="text-3xl md:text-5xl font-bold text-black mb-4 tracking-tight" data-id="element-999">
            Why Choose Walker's?
          </h2>
          <div className="w-20 h-1 bg-[#00D4FF] mx-auto mb-6" data-id="element-1000" />
          <p className="text-lg text-gray-600" data-id="element-1001">
            Martial arts is about more than just kicking and punching. It's
            about personal growth, character development, and building a strong
            foundation for life.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1002">
          {benefits.map((benefit, index) => <div key={benefit.title} className="animate-scroll-fade-up bg-white p-8 rounded-xl shadow-lg border border-gray-100 hover:shadow-xl hover:border-[#00D4FF]/30 transition-all group" style={{
          animationDelay: `${index * 0.1}s`
        }} data-id="element-1003">
              <div className={`w-14 h-14 rounded-lg bg-gray-50 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`} data-id="element-1004">
                <benefit.icon className={`w-8 h-8 ${benefit.color}`} data-id="element-1005" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#00D4FF] transition-colors" data-id="element-1006">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1007">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}